// Initial state
const state = {
    id: null,
    hash_id: null,
    fullname: null,
    name: null,
    firstName: null,
    secondName: null,
    profile: null,
    cat_user_type_id: null,
    cat_unity_id: null,
    cat_area_id: null,
    cat_department_id: null,
    cat_office_id: null,
    isaAdministrativeCoordinator: null,
    adminCoordinatorChanger: null,
    isResponsible: null,
    sem_user_id: null,
    disableRegister: null,
    office: null,
    userInfo: null,
    informatics: [],
    isAuthorizer: null,
    videos: []
};

// Getters
const getters = {
    userInfo: state => state.userInfo,
};

// Actions
const actions = {};

// Mutations
const mutations = {
    setUser: (state, user) => {
        state.id = user.id;
        state.hash_id = user.hash_id;
        state.fullname = user.fullname;
        state.name = user.name;
        state.firstName = user.firstName;
        state.secondName = user.secondName;
        state.profile = user.cat_profile_id;
        state.cat_user_type_id = user.cat_user_type_id;
        state.cat_unity_id = Number(user.cat_unity_id);
        state.cat_area_id = Number(user.cat_area_id);
        state.cat_department_id = Number(user.cat_department_id);
        state.cat_office_id = Number(user.cat_office_id);
        state.isaAdministrativeCoordinator = Boolean(user.isaAdministrativeCoordinator);
        state.adminCoordinatorChanger = Boolean(user.adminCoordinatorChanger);
        state.isResponsible = Boolean(user.isResponsible);
        state.sem_user_id = user.sem_user_id;
        state.disableRegister = user.disableRegister;
        state.office = user.office;
        state.userInfo = user.userInfo;
        state.informatics = user.informatics;
        state.isAuthorizer = user.isAuthorizer;
        state.videos = user.videos;


    },
    deleteUser: state => {
        state.id = null;
        state.hash_id = null;
        state.fullname = null;
        state.name = null;
        state.firstName = null;
        state.secondName = null;
        state.profile = null;
        state.cat_user_type_id = null;
        state.cat_unity_id = null;
        state.cat_area_id = null;
        state.cat_department_id = null;
        state.cat_office_id = null;
        state.isaAdministrativeCoordinator = null;
        state.adminCoordinatorChanger = null;
        state.isResponsible = null;
        state.sem_user_id = null;
        state.disableRegister = null;
        state.office = null;
        state.userInfo = null;
        state.informatics = [];
        state.isAuthorizer = null
        state.videos = []
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
